import { render } from "./PrintInvoiceMoneyDetailsDesign1.vue?vue&type=template&id=ce88e6d6"
import script from "./PrintInvoiceMoneyDetailsDesign1.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceMoneyDetailsDesign1.vue?vue&type=script&lang=js"

import "./PrintInvoiceMoneyDetailsDesign1.vue?vue&type=style&index=0&id=ce88e6d6&scoop=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__